import { VFC } from 'react';

import { Account } from 'dashboard/models/account';
import ResourceAccount from 'dashboard/modules/ResourceAccount';

interface RelatedAccountsProps {
  accounts: Account[];
}

const RelatedAccounts: VFC<RelatedAccountsProps> = ({ accounts }) => (
  <>
    {accounts.map((account) => (
      <ResourceAccount account={account} key={account.id} />
    ))}
  </>
);

export default RelatedAccounts;
